import { render, staticRenderFns } from "./Vacunas.vue?vue&type=template&id=3941fe7e"
import script from "./Vacunas.vue?vue&type=script&lang=js"
export * from "./Vacunas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports